{
  "name": "@flowlab/event",
  "version": "0.1.0",
  "description": "FlowLab event-driven system",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "flow-event": "./dist/cli/index.js"
  },
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.js"
    }
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "node build.js && tsc --emitDeclarationOnly --declaration --skipLibCheck --outDir dist",
    "dev": "tsup src/index.ts --watch",
    "test": "jest"
  },
  "keywords": [
    "event",
    "event-driven",
    "event-bus",
    "event-emitter",
    "event-handler",
    "event-listener",
    "event-dispatcher"
  ],
  "author": "luke king",
  "license": "MIT",
  "dependencies": {
    "cac": "^6.7.14",
    "esbuild": "^0.25.1",
    "eventemitter3": "^5.0.1",
    "ioredis": "^5.6.0",
    "picocolors": "^1.1.1"
  },
  "devDependencies": {
    "@types/jest": "^29.5.14",
    "jest": "^29.7.0",
    "ts-jest": "^29.3.0",
    "tsup": "^7.2.0",
    "typescript": "^5.3.3"
  }
}
